<template>
  <div
    class="i-base-checkbox"
    :class="{ checked: props.isChecked }"
    @click="toggleCheckbox"
  >
    <div
      class="checkbox"
      :class="{ checked: props.isChecked }"
    >
      <img
        v-if="props.isChecked"
        :src="iconCheckmarkWhite"
      />
    </div>
    <label>{{ props.label }}</label>
  </div>
</template>

<script setup lang="ts">
import iconCheckmarkWhite from "@/assets/icons/icon-checkmark-white.svg"

// Props

const props = defineProps({
  isChecked: {
    type: Boolean,
    required: true
  },
  label: {
    type: String,
    required: true
  }
})

// Emits

const emit = defineEmits(["toggle"])

// Functions

function toggleCheckbox() {
  emit("toggle", !props.isChecked)
}
</script>

<style scoped lang="scss">
.i-base-checkbox {
  align-items: center;
  border-radius: 10px;
  border: 1px solid $black300;
  cursor: pointer;
  display: flex;
  margin-bottom: 10px;
  padding: 8px;
  width: 100%;

  &.checked {
    background-color: $azure-radiance100;
    border: 1px solid $azure-radiance300;
  }

  .checkbox {
    align-items: center;
    border-radius: 4px;
    border: 1px solid black;
    display: flex;
    justify-content: center;
    margin-right: 10px;
    max-height: 24px;
    max-width: 24px;
    min-height: 24px;
    min-width: 24px;

    &.checked {
      background-color: $azure-radiance500;
      border: 1px solid $azure-radiance500;
    }

    img {
      height: auto;
      width: 60%;
    }
  }

  label {
    font-weight: normal;
    margin: 0;
    cursor: pointer;
  }
}
</style>
